export var StatusCode;
(function(StatusCode) {
    StatusCode[StatusCode["Ok"] = 200] = "Ok";
    StatusCode[StatusCode["NoContent"] = 204] = "NoContent";
    StatusCode[StatusCode["PermanentRedirect"] = 301] = "PermanentRedirect";
    StatusCode[StatusCode["TemporaryRedirect"] = 302] = "TemporaryRedirect";
    StatusCode[StatusCode["NotFound"] = 404] = "NotFound";
    StatusCode[StatusCode["Gone"] = 410] = "Gone";
})(StatusCode || (StatusCode = {}));
